import { Link } from 'react-router-dom';

// Until this block, `/anything` returned the app shell and rendered a blank page,
// which was harmless while `/` was the only real route. Now that links are
// shareable, an unmatched path is a plausible arrival — a truncated paste, a stale
// link — and a blank page would look like the site is broken.
const NotFound = ({ reason }) => {
    return (
        <div id="not-found">
            <p className="eyebrow">404 &middot; no specimen here</p>
            <h1 className="gallery-empty-title">Nothing at this coordinate.</h1>
            <p className="gallery-empty-sub">
                {reason || 'That address doesn’t match anything on the site.'}
            </p>
            {/* "Go to the generator" named a part of the system; this names what
                happens, and matches the same action everywhere else in the app. */}
            <Link to="/explore" className="btn-begin">Start zooming</Link>
        </div>
    );
};

export default NotFound;
